import { useEffect } from "react";
import { Child } from "pym.js";

export const usePymChild = () => {
  useEffect(() => {
    const pymChild = new Child({});
    const sendHeight = () => pymChild.sendHeight();

    sendHeight();
    const intervalId = setInterval(sendHeight, 500);

    return () => {
      clearInterval(intervalId);
      pymChild.remove();
    };
  }, []);
};
